<div class="customer-page">
  <div class="customer-form">
    <div class="header">{{ "prolindung.customerForm.heading" | translate }}</div>

    <div class="success-container">
      <div>
        <div class="success-header">
          <mat-icon>check_circle</mat-icon>
          {{ "prolindung.customerForm.successHeading" | translate }}
        </div>

        <div
          [innerHTML]="
            'prolindung.customerForm.successDesc'
              | translate
                : {
                    email: email
                  }
          "
        ></div>
      </div>

      <div>
        <div>{{ "prolindung.customerForm.successInfoTitle" | translate }}</div>

        <div class="success-wrapper">
          <div class="success-item" *ngFor="let field of fieldList">
            <div class="label">{{ field.codeDesc | translate }}</div>
            <div class="value">{{ field.codeValue }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>